<template>
	<div class="message-box">
		<h1>{{ $t('serverErrorCode') }}</h1>
		<h2 class="body-text-2">{{ $t('serverErrorMessage') }}</h2>
		<h3 class="heading-2">{{ $t('serverErrorInfo') }}</h3>
		<div class="buttons-con">
			<div class="action-link-wrap">
				<a
					onclick="history.back(-1)"
					class="link-button link-back-button"
					tabindex="0"
					>{{ $t('errorPageBack') }}</a
				>
				<router-link to="/" class="link-button">{{
					$t('errorPageToHome')
				}}</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import Accessibility from '@/mixins/Accessibility';
export default {
	mixins: [Accessibility],
	mounted() {
		this.$store.commit('setLoading', false);
		setTimeout(() => {
			this.announceError(this.$t('serverErrorInfo'));
		}, 200);
	}
};
</script>

<style scoped>
body {
	background-color: #2f3242;
}

.message-box {
	height: auto;
	margin: auto;
	text-align: center;
	color: #fff;
	font-family: 'RobotoRegular';
	font-weight: 300;
	color: #687682;
}

.message-box h1 {
	font-size: 6em;
	line-height: 0.5em;
	margin-bottom: 0.4em;
}
.message-box h2 {
	margin: 0;
}

.buttons-con .action-link-wrap {
	margin-top: 2.5em;
}

.buttons-con .action-link-wrap a {
	background: linear-gradient(123.25deg, #f82c5c 0%, #fcb98d 100%);
	padding: 8px 25px;
	border-radius: 4px;
	color: #fff;
	font-weight: bold;
	font-size: 14px;
	line-height: 21px;
	letter-spacing: 0.25px;
	transition: all 0.3s linear;
	cursor: pointer;
	text-decoration: none;
	margin-right: 10px;
	border: 2px solid transparent;
}

.buttons-con .action-link-wrap a:hover {
	border: 2px solid black;
}
</style>
